import React, { useEffect, useRef } from 'react';
import { Box, useTheme } from '@mui/material';
import { initCanvas, disposeCanvas } from '../services/canvasService';

const CanvasStage = ({ onReady, canvasRefExternal, outerRefExternal, transformRefExternal, panMode, onPanMouseDown, onPanMouseMove, onPanMouseUp }) => {
  const theme = useTheme();
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = initCanvas(canvasRef.current);
    onReady?.(canvas);
    return () => disposeCanvas(canvas);
    // run only once on mount; onReady is expected to be stable via useCallback
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      ref={outerRefExternal}
      onMouseDown={onPanMouseDown}
      onMouseMove={onPanMouseMove}
      onMouseUp={onPanMouseUp}
      onMouseLeave={onPanMouseUp}
      sx={{ flex: 1, height: '100%', bgcolor: theme.palette.background.default, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'auto', cursor: panMode ? 'grab' : 'default' }}
    >
      <Box ref={transformRefExternal} sx={{ transformOrigin: 'center center', display: 'inline-block' }}>
        <canvas ref={(el) => { canvasRef.current = el; if (canvasRefExternal) canvasRefExternal.current = el; }} style={{ border: `1px solid ${theme.palette.divider}`, boxShadow: theme.palette.shadows ? `0 0 20px ${theme.palette.shadows[5]}` : `0 0 20px ${theme.palette.action.disabled}` }} />
      </Box>
    </Box>
  );
};

export default CanvasStage;
